
    <h1 mat-dialog-title style="text-align:center;">Warning!</h1>
    <div>
      <pre style="white-space: break-spaces;">{{data.message}}</pre>
    </div>
    <div style="position: relative;margin-top: 10px;top: 20px;left: 42px;width: 70%;">
      <button mat-button (click)="dref.close()"  style="position: relative;left: 50%;background: #ffffffaf;">Close</button>
    </div>
  